const actions = {
  UPDATE_OPTIONS: 'UPDATE_OPTIONS',
  updateOptions: (options) => ({
    type: actions.UPDATE_OPTIONS,
    options,
  }),
};
export default actions;
